/**
 * Auto-load timer data from a selected entry
 * @param {Object} params - Parameters object
 * @param {string} params.task - Task name
 * @param {string} params.project_id - Project ID
 * @param {string} params.projectName - Project name
 * @param {string} params.tag_name - Tag name
 * @param {string} params.tag_id - Tag ID
 * @param {string} params.client - Client name
 * @param {string} params.clientId - Client ID
 * @param {string} params.sprint_name - Sprint name
 * @param {string} params.sprint_id - Sprint ID
 * @param {string} params._id - Entry ID
 * @param {boolean} params.billable - Billable status
 * @param {Object} params.setters - Object containing setter functions
 * @param {Function} params.setters.setTaskName - Setter for task name
 * @param {Function} params.setters.setProjectName - Setter for project name
 * @param {Function} params.setters.setProjectId - Setter for project ID
 * @param {Function} params.setters.setTag - Setter for tag name
 * @param {Function} params.setters.setTagId - Setter for tag ID
 * @param {Function} params.setters.setClient - Setter for client name
 * @param {Function} params.setters.setClientId - Setter for client ID
 * @param {Function} params.setters.setSprintName - Setter for sprint name
 * @param {Function} params.setters.setSprintId - Setter for sprint ID
 * @param {Function} params.setters.setIsBillable - Setter for billable status
 * @param {Function} params.setters.setDropdownVisible - Setter for dropdown visibility
 */
export function autoLoadTimerData({
  task,
  project_id,
  projectName,
  tag_name,
  tag_id,
  client,
  clientId,
  sprint_name,
  sprint_id,
  _id,
  billable,
  setters: {
    setTaskName,
    setProjectName,
    setProjectId,
    setTag,
    setTagId,
    setClient,
    setClientId,
    setSprintName,
    setSprintId,
    setIsBillable,
    setDropdownVisible,
  },
}) {
  try {
    if (!task || !project_id || !projectName || !client || !clientId || !sprint_name || !sprint_id) {
      console.warn("autoLoadTimerData: Missing required parameters.", {
        task,
        project_id,
        projectName,
        tag_name,
        tag_id,
        client,
        clientId,
        sprint_name,
        sprint_id,
        _id,
        billable
      });
    }

    setTaskName(task);
    setProjectName(projectName);
    setProjectId(project_id);
    setTag(tag_name);
    setTagId(tag_id);
    setClient(client);
    setClientId(clientId);
    setSprintName(sprint_name);
    setSprintId(sprint_id);
    setIsBillable(billable);
    setDropdownVisible(false);
  } catch (error) {
    console.error("Error in autoLoadTimerData:", error);
  }
}
